import parse from 'html-react-parser';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import angelEvaluation from '../../../../assets/images/angelEvaluation.png';
import ocularMotility from '../../../../assets/images/ocularMotility.png';
import { lineHeightStyle, styledComponent } from '../../../../utils/helpers';
import ChiefComplainDeleteBtn from '../chiefComplainDeleteBtn';

const OcularExaminationView = ({
  prescriptionItems,
  selectedOnExamination,
  setSelectedOnExamination,
  isHistoryPage,
}) => {
  let { ocularExamination } = selectedOnExamination;
  const crossIcon = '<i className="far fa-times-circle"></i>';
  const checkedIcon = '<i className="fas fa-check-circle"></i>';
  const capitalizeFirstChar = (str) => str.replace(/^./, str[0].toUpperCase());

  const removeItemsData = (fieldName) => {
    if (fieldName === 'pl') {
      ocularExamination.pl = {
        present: false,
        absent: false,
      };
    } else if (fieldName === 'fc') {
      ocularExamination.fc = '';
    } else if (fieldName === 'hm') {
      ocularExamination.hm = {
        present: false,
        absent: false,
      };
    } else if (fieldName === 'dr') {
      ocularExamination.dr = {
        present: false,
        absent: false,
      };
    } else if (fieldName === 'visualAcuity') {
      ocularExamination.visualAcuity = {
        val: '',
        var: '',
      };
    } else if (fieldName === 'pr') {
      ocularExamination.pr = {
        first: false,
        second: false,
        third: false,
        fourth: false,
      };
    } else if (fieldName === 'ocularMotility') {
      ocularExamination.ocularMotility = {
        od: {
          first: false,
          second: false,
          third: false,
          fourth: false,
          fifth: false,
          sixth: false,
        },
        os: {
          first: false,
          second: false,
          third: false,
          fourth: false,
          fifth: false,
          sixth: false,
        },
      };
    } else if (fieldName === 'colorVision') {
      ocularExamination.colorVision = {
        normal: false,
        deficit: false,
        red: false,
        blue: false,
        green: false,
      };
    } else if (fieldName === 'angleEvaluationBefore') {
      ocularExamination.angleEvaluationBefore = {
        od: {
          first: '',
          second: '',
          third: '',
          fourth: '',
        },
        os: {
          first: '',
          second: '',
          third: '',
          fourth: '',
        },
      };
    } else if (fieldName === 'angleEvaluationAfter') {
      ocularExamination.angleEvaluationAfter = {
        od: {
          first: '',
          second: '',
          third: '',
          fourth: '',
        },
        os: {
          first: '',
          second: '',
          third: '',
          fourth: '',
        },
      };
    } else {
      ocularExamination.iop = {
        high: '',
        low: '',
      };
    }
    selectedOnExamination.ocularExamination = ocularExamination;
    setSelectedOnExamination({ ...selectedOnExamination });
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['on-examination']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['on-examination']?.subItemStyle || {},
  );

  const flexRow = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  return (
    <>
      {ocularExamination && (
        <ul
          style={lineHeightStyle('on-examination', prescriptionItems)}
          key={`visualAcuity`}
        >
          {(ocularExamination['visualAcuity'].val ||
            ocularExamination['visualAcuity'].var) && (
            <li className="text-left" style={flexRow}>
              <span>
                <Title>Visual Acuity: VAR:</Title>{' '}
                <Value>{ocularExamination['visualAcuity'].var}</Value>,
                <Title> VAL:</Title>{' '}
                <Value>{ocularExamination['visualAcuity'].val}</Value>
              </span>
              {!isHistoryPage && (
                <ChiefComplainDeleteBtn
                  action={removeItemsData}
                  itemName={'visualAcuity'}
                />
              )}
            </li>
          )}
          {(ocularExamination?.pl?.present ||
            ocularExamination?.pl?.absent) && (
            <li className="text-left" style={flexRow}>
              <span>
                <Title>PL:</Title>{' '}
                <Value>
                  {ocularExamination?.pl?.present ? 'Present' : 'Absent'}
                </Value>
              </span>
              {!isHistoryPage && (
                <ChiefComplainDeleteBtn
                  action={removeItemsData}
                  itemName={'pl'}
                />
              )}
            </li>
          )}
          {ocularExamination?.fc && (
            <li className="text-left" style={flexRow}>
              <span>
                <Title>FC:</Title> <Value>{ocularExamination?.fc} ft</Value>
              </span>
              {!isHistoryPage && (
                <ChiefComplainDeleteBtn
                  action={removeItemsData}
                  itemName={'fc'}
                />
              )}
            </li>
          )}
          {(ocularExamination?.hm?.present ||
            ocularExamination?.hm?.absent) && (
            <li className="text-left" style={flexRow}>
              <span>
                <Title>HM:</Title>{' '}
                <Value>
                  {ocularExamination?.hm?.present ? 'Present' : 'Absent'}
                </Value>
              </span>
              {!isHistoryPage && (
                <ChiefComplainDeleteBtn
                  action={removeItemsData}
                  itemName={'hm'}
                />
              )}
            </li>
          )}
          {(ocularExamination?.dr?.present ||
            ocularExamination?.dr?.absent) && (
            <li className="text-left" style={flexRow}>
              <span>
                <Title>DR:</Title>{' '}
                <Value>
                  {ocularExamination.dr.present ? 'Present' : 'Absent'}
                </Value>
              </span>
              {!isHistoryPage && (
                <ChiefComplainDeleteBtn
                  action={removeItemsData}
                  itemName={'dr'}
                />
              )}
            </li>
          )}
          {Object.values(ocularExamination?.pr).includes(true) && (
            <li>
              <span className="pt-5">
                <Title>PR:</Title>
              </span>
              <div className="d-flex justify-content-between align-items-center">
                <div
                  className="pr-area position-relative"
                  style={{
                    marginLeft: '50px',
                    minWidth: '70px',
                    minHeight: '70px',
                  }}
                >
                  <span
                    style={{ position: 'absolute', top: '-14px', left: '43px' }}
                  >
                    {ocularExamination?.pr?.first
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{ position: 'absolute', top: '8px', right: '20px' }}
                  >
                    {ocularExamination?.pr?.second
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <img
                    src={angelEvaluation}
                    height={35}
                    width={35}
                    alt="PR Evaluation"
                  />
                  <span
                    style={{
                      position: 'absolute',
                      bottom: '20px',
                      left: '42px',
                    }}
                  >
                    {ocularExamination?.pr?.third
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{ position: 'absolute', top: '8px', left: '16px' }}
                  >
                    {ocularExamination?.pr?.fourth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                </div>
                <div>
                  {!isHistoryPage && (
                    <ChiefComplainDeleteBtn
                      action={removeItemsData}
                      itemName={'pr'}
                    />
                  )}
                </div>
              </div>
            </li>
          )}
          {(ocularExamination?.iop?.high || ocularExamination?.iop?.low) && (
            // <li
            //   className="text-left pt-2 pb-2"
            //   style={{ position: 'relative' }}
            // >
            //   <Title>IOP: </Title>
            //   <img src={iopImg} height={50} width={100} alt="IOP" />
            //   {ocularExamination?.iop?.high && (
            //     <span
            //       style={{ position: 'absolute', top: '45px', left: '45px' }}
            //     >
            //       {ocularExamination?.iop?.high} mmHg
            //     </span>
            //   )}
            //   {ocularExamination?.iop?.low && (
            //     <span
            //       style={{ position: 'absolute', top: '45px', left: '115px' }}
            //     >
            //       {ocularExamination?.iop?.low} mmHg
            //     </span>
            //   )}
            //   {!isHistoryPage && (
            //     <ChiefComplainDeleteBtn action={removeItemsData} itemName={'iop'} />
            //   )}
            // </li>
            <li
              className="text-left pt-2 pb-2"
              style={{ position: 'relative' }}
            >
              <Title>IOP: </Title>
              <span style={{ fontSize: '28px', paddingLeft: '20px' }}>
                A
                {ocularExamination?.iop?.high && (
                  <span
                    style={{
                      position: 'absolute',
                      fontSize: '14px',
                      top: '25px',
                      left: '48px',
                    }}
                  >
                    {ocularExamination?.iop?.high}
                  </span>
                )}
                {ocularExamination?.iop?.low && (
                  <span
                    style={{
                      position: 'absolute',
                      top: '25px',
                      fontSize: '14px',
                      left: '72px',
                      fontWeight: 'normal',
                    }}
                  >
                    {ocularExamination?.iop?.low}
                  </span>
                )}
              </span>

              {!isHistoryPage && (
                <ChiefComplainDeleteBtn
                  action={removeItemsData}
                  itemName={'iop'}
                />
              )}
            </li>
          )}
          {Object.values(ocularExamination?.colorVision).includes(true) && (
            <li className="text-left mt-1" style={flexRow}>
              <span>
                <Title>Color Vision:</Title>{' '}
                {Object.keys(ocularExamination?.colorVision).map(
                  (data, key) => {
                    return ocularExamination?.colorVision[data] === true ? (
                      <span key={key} className="pr-1">
                        <Value>{capitalizeFirstChar(data)},</Value>
                      </span>
                    ) : (
                      ''
                    );
                  },
                )}
              </span>
              {!isHistoryPage && (
                <ChiefComplainDeleteBtn
                  action={removeItemsData}
                  itemName={'colorVision'}
                />
              )}
            </li>
          )}
          {(Object.values(ocularExamination?.ocularMotility?.od).includes(
            true,
          ) ||
            Object.values(ocularExamination?.ocularMotility?.os).includes(
              true,
            )) && (
            <li className="text-left mt-3" style={{ position: 'relative' }}>
              <Row>
                <Col md={3}>
                  <div>
                    <Title>Ocular Motility:</Title>
                  </div>
                </Col>
                <Col>
                  <span style={{ position: 'absolute', left: '16px' }}>
                    {ocularExamination?.ocularMotility?.od?.sixth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{ position: 'absolute', top: '0px', left: '67px' }}
                  >
                    {ocularExamination?.ocularMotility?.od?.first
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <img src={ocularMotility} height="70" width="70"></img>

                  <span
                    style={{ position: 'absolute', top: '25px', left: '3px' }}
                  >
                    {ocularExamination?.ocularMotility?.od?.fifth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      bottom: '-3px',
                      left: '67px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.od?.third
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      left: '15px',
                      bottom: '-3px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.od?.fourth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      top: '25px',
                      left: '76px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.od?.second
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                </Col>

                <Col>
                  <span
                    style={{ position: 'absolute', top: '0px', left: '18px' }}
                  >
                    {ocularExamination?.ocularMotility?.os?.sixth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{ position: 'absolute', top: '0px', left: '66px' }}
                  >
                    {ocularExamination?.ocularMotility?.os?.first
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <img src={ocularMotility} height="70" width="70"></img>
                  <span
                    style={{ position: 'absolute', top: '25px', left: '3px' }}
                  >
                    {ocularExamination?.ocularMotility?.os?.fifth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      bottom: '-1px',
                      left: '66px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.os?.third
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      left: '18px',
                      bottom: '-3px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.os?.fourth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      top: '25px',
                      left: '76px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.os?.second
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                </Col>
                <Col md={1}>
                  {!isHistoryPage && (
                    <ChiefComplainDeleteBtn
                      action={removeItemsData}
                      itemName={'ocularMotility'}
                    />
                  )}
                </Col>
              </Row>
            </li>
          )}
          {(Object.values(ocularExamination?.angleEvaluationBefore?.od).some(
            (val) => val !== '',
          ) ||
            Object.values(ocularExamination?.angleEvaluationBefore?.os).some(
              (val) => val !== '',
            )) && (
            <li className="text-left" style={{ position: 'relative' }}>
              <Row className="pt-4">
                <Col md={3}>
                  <div>
                    <Title>Angle Evaluation:</Title>
                  </div>
                </Col>
                <Col>
                  {Object.values(
                    ocularExamination.angleEvaluationBefore.od,
                  ).some((val) => val !== '') && (
                    <div className="angle-evaluation view-angle-evaluation">
                      <span
                        style={{
                          left: '38px',
                          top: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.od.first}
                      </span>
                      <span
                        style={{
                          top: '39px',
                          right: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.od.second}
                      </span>
                      <img src={angelEvaluation} height={70} width={70}></img>

                      <span
                        style={{
                          top: '39px',
                          left: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.od.fourth}
                      </span>
                      <span
                        style={{
                          bottom: '0px',
                          left: '38px',
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.od.third}
                      </span>
                    </div>
                  )}
                </Col>
                <Col>
                  {Object.values(
                    ocularExamination.angleEvaluationBefore.os,
                  ).some((val) => val !== '') && (
                    <div className="angle-evaluation view-angle-evaluation">
                      <span
                        style={{
                          left: '38px',
                          top: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.os.first}
                      </span>
                      <span
                        style={{
                          top: '39px',
                          right: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.os.second}
                      </span>
                      <img src={angelEvaluation} height={70} width={70}></img>
                      <span
                        style={{
                          top: '39px',
                          left: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.os.fourth}
                      </span>
                      <span
                        style={{
                          bottom: '0px',
                          left: '38px',
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.os.third}
                      </span>
                    </div>
                  )}
                </Col>
                <Col md={1}>
                  {!isHistoryPage && (
                    <ChiefComplainDeleteBtn
                      action={removeItemsData}
                      itemName={'angleEvaluationBefore'}
                    />
                  )}
                </Col>
              </Row>
            </li>
          )}
          {(Object.values(ocularExamination.angleEvaluationAfter.od).some(
            (val) => val !== '',
          ) ||
            Object.values(ocularExamination.angleEvaluationAfter.os).some(
              (val) => val !== '',
            )) && (
            <li className="text-left" style={{ position: 'relative' }}>
              <Row className="pt-4">
                <Col md={3}>
                  <Title>After Indentation:</Title>
                </Col>
                <Col>
                  {Object.values(
                    ocularExamination.angleEvaluationAfter.od,
                  ).some((val) => val !== '') && (
                    <div className="angle-evaluation view-angle-evaluation">
                      <span
                        style={{
                          left: '38px',
                          top: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.od.first}
                      </span>
                      <span
                        style={{
                          top: '39px',
                          right: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.od.second}
                      </span>
                      <img src={angelEvaluation} height={70} width={70}></img>
                      <span
                        style={{
                          top: '39px',
                          left: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.od.fourth}
                      </span>
                      <span
                        style={{
                          bottom: '0px',
                          left: '38px',
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.od.third}
                      </span>
                    </div>
                  )}
                </Col>
                <Col>
                  {Object.values(
                    ocularExamination.angleEvaluationAfter.os,
                  ).some((val) => val !== '') && (
                    <div className="angle-evaluation view-angle-evaluation">
                      <span
                        style={{
                          left: '38px',
                          top: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.os.first}
                      </span>
                      <span
                        style={{
                          top: '39px',
                          right: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.os.second}
                      </span>
                      <img src={angelEvaluation} height={70} width={70}></img>
                      <span
                        style={{
                          top: '39px',
                          left: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.os.fourth}
                      </span>
                      <span
                        style={{
                          bottom: '0px',
                          left: '38px',
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.os.third}
                      </span>
                    </div>
                  )}
                </Col>
                <Col md={1}>
                  {!isHistoryPage && (
                    <ChiefComplainDeleteBtn
                      action={removeItemsData}
                      itemName={'angleEvaluationAfter'}
                    />
                  )}
                </Col>
              </Row>
            </li>
          )}
        </ul>
      )}
    </>
  );
};

export default OcularExaminationView;
